import usersRepository from './usersRepository'
import devicesRepository from './devicesRespository'
import parametersRespository from './parametersRespository'
import addressesRespository from './addressesRespository'
import targetsRespository from './targetsRespository'
import tanksReposository from './tanksRespository'
import temperaturesReposository from './temperaturesRespository'
import personsReposository from './personsRepository'
import targetAlertsRespository from './targetAlertsRespository'
import targetdDevicesRespository from './targetdDevicesRespository'

const repositories = {
    users: usersRepository,
    devices: devicesRepository,
    parameters: parametersRespository,
    addresses: addressesRespository,
    targets: targetsRespository,
    tanks: tanksReposository,
    temperatures: temperaturesReposository,
    persons: personsReposository,
    targetAlerts: targetAlertsRespository,
    targetdDevices: targetdDevicesRespository,
}

export const repositoryFactory = {
    get: name => repositories[name],
}
